import React, { useState } from "react";
import Preview from "./Preview";

export default function MostRepeatedMedia({ medias, mostRepetedMedia }) {
    const [IsShowing, setIsShowing] = useState(false);

    function handleClose() {
        setIsShowing(false);
    }

    return (
        <>
            <div className="info-box shadow-sm" onClick={() => setIsShowing(true)} style={{ cursor: "pointer" }}>
                <span className="info-box-icon bg-dark">
                    <i className="fas fa-photo-video" />
                </span>
                <div className="info-box-content">
                    <span className="info-box-text">Most Repeated Media</span>
                    <span className="info-box-number">{mostRepetedMedia}</span>
                </div>
            </div>
            {IsShowing && (
                <div className={`modal fade show`} id="modal-default" style={{ display: "block", paddingRight: 17 }} aria-modal="true" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Screens List</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => handleClose()}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <table className="table   text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Repeat Count</th>
                                                    <th width={300}>Medias</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {medias?.length === 0 && (
                                                    <tr style={{ textAlign: "center" }}>
                                                        <td colSpan={8}>No Screen Found</td>
                                                    </tr>
                                                )}
                                                {medias?.map((media, i) => (
                                                    <tr key={i}>
                                                        <td>{media.count || 0}</td>
                                                        {media.type === "text" && <td>{media.text}</td>}
                                                        {media.type === "photo" && (
                                                            <td width={300}>
                                                                <div className="row">
                                                                    {media.image?.length > 0 &&
                                                                        media.image?.map((uro) => (
                                                                            <div className="col-2 col-md-2 p-3">
                                                                                <Preview url={uro} type="photo" />
                                                                            </div>
                                                                        ))}
                                                                </div>
                                                            </td>
                                                        )}
                                                        {media.type === "video" && <td>{media.video && <Preview url={media.video} type="video" />}</td>}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
